import React from 'react'

const BuildIcon = () => {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.1492 11.6585C15.1492 12.5745 14.4066 13.3171 13.4906 13.3171C12.5747 13.3171 11.8321 12.5745 11.8321 11.6585C11.8321 10.7426 12.5747 10 13.4906 10C14.4066 10 15.1492 10.7426 15.1492 11.6585Z" fill="#5CB9E5" />
            <path d="M11.003 27V16.6342C11.003 15.8049 10.9051 14.1464 11.8322 14.1463L20.5394 14.1463L20.5396 15.8049H15.9786V27H14.32V21.6098H12.6615V27H11.003Z" fill="#5CB9E5" />
            <path d="M25.9297 10.8293H16.8077V12.4878H24.2711V19.9512H17.637V21.6097H20.1248L21.7833 26.5854H23.4419L21.7833 21.6097H25.9297V10.8293Z" fill="#5CB9E5" />
        </svg>

    )
}

export default BuildIcon
